module.exports = __webpack_public_path__ + "static/img/14000292.b94c3826.png";